import WordDocuments    from '../pages/word_documents';
import Home    from '../pages/home';

const routes = () =>  [

    {
        path: "/:division/:word_document",
        component: WordDocuments,
    },
    {
        path: "/:division",
        component: WordDocuments,
    },
    {
        path: "",
        component: Home,
    },
   
]

export default routes;
